import apiService from '../../../services/api-client';
import { GetGoogleSyncResponse } from '../interfaces/get-google-sync';
import { GetMeCoursesResponse } from '../interfaces/get-me-courses';
import { GetMeUserResponse } from '../interfaces/get-me-user';
import { PutMePasswordPayloadRequest, PutMePasswordResponse } from '../interfaces/put-me-password';
import { PutMeUserPayloadRequest, PutMeUserResponse } from '../interfaces/put-me-user';

export const meApiService = {
  async getMeUser() {
    const { data } = await apiService().get<GetMeUserResponse>(`users/me`);
    return data;
  },
  async putMeUser(body: PutMeUserPayloadRequest) {
    const formData = new FormData();
    if (body.name)
      formData.append('name', body.name);
    if (body.city)
      formData.append('city', body.city);
    if (body.country)
      formData.append('country', body.country);
    if (body.phone)
      formData.append('phone', body.phone);
    if (body.rut)
      formData.append('rut', body.rut);
    
    if (body.selectedAvatar) {
      formData.append('avatar', body.selectedAvatar);
    }

    const { data } = await apiService().put<PutMeUserResponse>(`users/me`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
  async getMeCourses() {
    const { data } = await apiService().get<GetMeCoursesResponse>(`courses/me`);
    return data;
  },
  async putMePassword(body: PutMePasswordPayloadRequest) {
    const { data } = await apiService().put<PutMePasswordResponse>(`users/me/change-password`, body);
    return data;
  },
  async getGoogleSync() {
    const { data } = await apiService().get<GetGoogleSyncResponse>(
      `users/me/google/sync`
    );
    return data;
  },
  async getGoogleStatus() {
    const { data } = await apiService().get<any>(`users/me/google/status`);
    return data;
  },
};
